import { RouteRecordRaw } from "vue-router";

const birthdaysRoutes: Array<RouteRecordRaw> = [
  {
    path: "/birthdays",
    name: "birthdays",
    component: () => import("./views/BirthdaysView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

export default birthdaysRoutes;
